module.exports = __webpack_public_path__ + "img/profile02.9b50a26a.jpg";